(function($) {
    
    const roomDetailPopupInit = function (selector) {
        
        $.magnificPopup.open({
            type: 'inline',
            items: {
                src: '#room_details'
            },
            mainClass: 'component-popup mfp-slide-up',
            removalDelay: 200, 
            //callbacks: {
            //    ajaxContentAdded: function () {
            //        roomDetailPopupInit(this.content);
            //    }
            //}
        });        
        
        var $content = $(selector);
        var thumbImages = $content.find('.js-thumb-carousel');
        var thumbGallery = new Swiper(thumbImages, {
            loop: false,
            spaceBetween: 8,
            slidesPerView: 8,
            watchSlidesVisibility: true
        });

        var mainImages = $content.find('.js-room-carousel').get(0);
        var mainGallery = new Swiper(mainImages, {
            loop: true,
            spaceBetween: 10,
            thumbs: {
                swiper: thumbGallery
            },
            navigation: {
                prevEl: '.component-slider__button--prev',
                nextEl: '.component-slider__button--next'
            },
            pagination: {
                el: '.component-slider__pagination',
                type: 'fraction'
            }
        });

        //var svgloader = window.TL.ui.svgloader;
        //$content.find('[data-svg]').each( (i, el) => svgloader(el) );
    };

    if (window.RoomDetailPopupInit === undefined) {
        window.RoomDetailPopupInit = roomDetailPopupInit
    }
})(jQuery);
